// Sorting of the per-entity tables ("Por cancha", "Por profesional"), shared by the statistics screens.

/** Sorted copy of the rows. `dir` is 1 (ascending) or -1; rows without a value always go last. */
export const sortRows = (rows, key, dir) =>
  [...rows].sort((a, b) => {
    const va = a[key];
    const vb = b[key];
    if (va == null && vb == null) return 0;
    if (va == null) return 1;
    if (vb == null) return -1;
    return key === "name" ? dir * va.localeCompare(vb, "es") : dir * (va - vb);
  });

/** Sort state after clicking a column header: same column flips, a new one starts at its natural direction. */
export const nextSort = (current, key) => ({
  key,
  dir: current.key === key ? -current.dir : key === "name" ? 1 : -1,
});
